import { ChannelStats } from '@kaltura-ott/tvpil';

import { fetchMostWatchedQuery } from '../../rhino/data/mostWatched/fetchMostWatchedQuery';
import { getTopXWatched } from '../../rhino/data/mostWatched/getTopXWatched';
import { trackWatchCount } from '../../rhino/data/mostWatched/trackWatchCount';

/**
 * @category Store
 */
export class ChannelStatsStore {
  stats?: ChannelStats[];

  saveChannelStats(id: number, userId: string, date = new Date()): void {
    trackWatchCount({ userId: Number(userId), channelId: id });
  }

  async loadChannelStats(userId: string) {
    this.stats = await fetchMostWatchedQuery(userId);
  }

  public getMostWatched(weeksCount = 4, count = 0) {
    return getTopXWatched({ watchStats: this.stats ?? [], watchPeriod: weeksCount, topX: count });
  }
}

export const channelStats = new ChannelStatsStore();
